import DataRevealFields from '../dataRevealFields'

class DataLazyRevealFields extends DataRevealFields {
  $currentTarget: JQuery;
  $fieldset: JQuery;

  protected get dataCheckFieldName() {
    return "data-lazy-check-field";
  }
  protected get dataRevealFieldName() {
    return "data-lazy-reveal-field";
  }

  preInit() {
    super.preInit();
    $(document).on('show.bs.collapse fieldsAdded lazyReveal', '.expandable-form', (event) => {
      this.$currentTarget = $(event.currentTarget);
      let $toggleFields = this.$currentTarget.find(this.selectorAll);
      $toggleFields.each((ind, field) => this.toggleField(ind, field));
    });
  }

  protected toggleAllFields() {
    // only show visible ones - as of right now they are never visible on page load
  }

  protected getDefaultParentContainer() {
    if (this.$currentTarget){
      return this.$currentTarget

    }else{
      return $(document)
    }
  }
}

let dataRevealFields = new DataLazyRevealFields();
dataRevealFields.preInit();
$(document).on('turbo:load turbo:render', () => {

  dataRevealFields.init();
});
